import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type {
  AysCodeGroup,
  AysCodeResponse,
} from '@bindoc-projects/code-domain-lib';
import {
  AysCode
} from '@bindoc-projects/code-domain-lib';

export const BD_DRG_MDC_CONTENT_CONDITION_ID = 'drgMdc';
export const FilterConditionDrgMdcPluginType: FilterConditionPluginSpecification<
  AysCode[],
  FilterConditionDrgMdcDto,
  BdDrgMdcContentCondition
> = {
  type: 'drgMdc',
  category: 'case',
  displayName: { de: 'DRG-Kapitel' },
  sortingIndex: 10,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionDrgMdcDto,
  ): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionDrgMdcPlugin(
        obj.codes.map((it) => AysCode.fromObject(it)),
      );
  },
  fromCondition(
    jsonObj: BdDrgMdcContentCondition,
  ): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionDrgMdcPlugin(
        (jsonObj.includes ?? []).map((it) => AysCode.fromObject(it)),
      );
  },
  newInstance(): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionDrgMdcPlugin([]);
  },
};

export class FilterConditionDrgMdcPlugin extends FilterConditionPluginImpl<
  AysCode[],
  FilterConditionDrgMdcDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    AysCode[],
    FilterConditionDrgMdcDto,
    BdDrgMdcContentCondition
  > = FilterConditionDrgMdcPluginType;

  constructor(private codes: AysCodeGroup[]) {
    super(FilterConditionDrgMdcPluginType.type);
  }

  clone(): FilterConditionDrgMdcPlugin {
    return new FilterConditionDrgMdcPlugin([
      ...this.codes.map((it) => it.clone()),
    ]);
  }

  override equals(other: FilterConditionDrgMdcPlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(
        this.codes,
        other.codes,
        (a, b) => a.name === b.name && a.codingSystem === b.codingSystem,
      )
    );
  }

  override validationToText(): string {
    if (this.codes.length === 0) {
      return 'Mindestens ein DRG-Kapitel auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new BdDrgMdcContentCondition(this.codes, []);
  }

  toJSON(): FilterConditionDrgMdcDto | null {
    return {
      type: this.type,
      codes: this.codes,
    };
  }

  toText(): string | null {
    return 'DRG-Kapitel';
  }

  toValue(): AysCodeGroup[] {
    return this.codes;
  }
}

export class BdDrgMdcContentCondition extends BdContentCondition<AysCode> {
  constructor(includes: AysCodeGroup[], excludes: AysCodeGroup[]) {
    super(BD_DRG_MDC_CONTENT_CONDITION_ID, includes, excludes);
  }
}

interface FilterConditionDrgMdcDto {
  type: string;
  codes: AysCodeResponse[];
}
